import { Injectable } from '@angular/core';
import { HttpClient, HttpErrorResponse, HttpHeaders  } from '@angular/common/http';
import { Interestpayments } from "./interestpayments.model";
import { Savings } from "./savings.model";
import { environment } from '../../../environments/environment';

@Injectable({
  providedIn: 'root'
})

@Injectable({
  providedIn: 'root'
})
export class InterestpaymentsService {

  public selectedInterestPayments : Interestpayments;
  private selectedSavings : Savings;

  constructor(private httpClient: HttpClient) { }

  getBaseUrl() {  
    // return 'http://localhost:59355/';
    return environment.baseUrl;
   }  

   IUDInterestPayments(interestpayments: Interestpayments) {

   console.log(interestpayments) ;

    interestpayments.CompanyId = + JSON.parse(localStorage.getItem("EmployeeData"))["CompanyId"];
    interestpayments.EmployeeBranchId = + JSON.parse(localStorage.getItem("EmployeeData"))["BranchId"];
    interestpayments.EmployeeId =+ JSON.parse(localStorage.getItem("EmployeeData"))["Id"];
    interestpayments.SaasId = + JSON.parse(localStorage.getItem("EmployeeData"))["SaasId"];

    // var body = JSON.stringify(interestpayments);
    // var headerOptions = new Headers({ 'Content-Type': 'application/json' });
    // var requestOptions = new RequestOptions({ method: RequestMethod.Post, headers: headerOptions });
    // return this.http.post(this.getBaseUrl() + 'api/SavingsPayments/IUD', body, requestOptions).map(x => x.json());
  
    let body = interestpayments;
    const headers = new HttpHeaders();
    headers.set('Content-Type', 'application/json; charset=utf-8');
    return this.httpClient.post<any>( this.getBaseUrl() +  'api/SavingsPayments/IUD', body,{headers: headers});
  }

  FetchInterestPaymentsList(){

    this. selectedInterestPayments = new Interestpayments();
    this.selectedInterestPayments.CompanyId = + JSON.parse(localStorage.getItem("EmployeeData"))["CompanyId"];
    this.selectedInterestPayments.EmployeeBranchId = + JSON.parse(localStorage.getItem("EmployeeData"))["BranchId"];
    this.selectedInterestPayments.EmployeeId =+ JSON.parse(localStorage.getItem("EmployeeData"))["Id"];
    this.selectedInterestPayments.SaasId = + JSON.parse(localStorage.getItem("EmployeeData"))["SaasId"];

    // var body = JSON.stringify(this.selectedInterestPayments);
    // var headerOptions = new Headers({ 'Content-Type': 'application/json' });
    // var requestOptions = new RequestOptions({ method: RequestMethod.Post, headers: headerOptions });
    // return this.http.post(this.getBaseUrl() + 'api/SavingsPayments/Fetch', body, requestOptions).map(x => x.json());
    
    let body = this.selectedInterestPayments;
    const headers = new HttpHeaders();
    headers.set('Content-Type', 'application/json; charset=utf-8');
    return this.httpClient.post<any>( this.getBaseUrl() +  'api/SavingsPayments/FetchList', body,{headers: headers});
  }

  FetchDepositNoList(){
    
    this.selectedSavings= new Savings();
    this.selectedSavings.CompanyId = + JSON.parse(localStorage.getItem("EmployeeData"))["CompanyId"];
    this.selectedSavings.EmployeeBranchId = + JSON.parse(localStorage.getItem("EmployeeData"))["BranchId"];
    this.selectedSavings.EmployeeId =+ JSON.parse(localStorage.getItem("EmployeeData"))["Id"];
    this.selectedSavings.SaasId = + JSON.parse(localStorage.getItem("EmployeeData"))["SaasId"];

    // var body = JSON.stringify(this.selectedSavings);
   
    // var headerOptions = new Headers({ 'Content-Type': 'application/json' });
    // var requestOptions = new RequestOptions({ method: RequestMethod.Post, headers: headerOptions });
    // return this.http.post( this.getBaseUrl() +  'api/Savings/FetchList', body, requestOptions).map(x => x.json());
    let body = this.selectedSavings;
    const headers = new HttpHeaders();
    headers.set('Content-Type', 'application/json; charset=utf-8');
    return this.httpClient.post<any>( this.getBaseUrl() +  'api/Savings/FetchList', body,{headers: headers});
  }

  FetchInterestPaymentsById(interestpayments: Interestpayments){

    interestpayments.CompanyId = + JSON.parse(localStorage.getItem("EmployeeData"))["CompanyId"];
    interestpayments.EmployeeBranchId = + JSON.parse(localStorage.getItem("EmployeeData"))["BranchId"];
    interestpayments.EmployeeId =+ JSON.parse(localStorage.getItem("EmployeeData"))["Id"];
    interestpayments.SaasId = + JSON.parse(localStorage.getItem("EmployeeData"))["SaasId"];

    // var body = JSON.stringify(interestpayments);
    // var headerOptions = new Headers({ 'Content-Type': 'application/json' });
    // var requestOptions = new RequestOptions({ method: RequestMethod.Post, headers: headerOptions });
    // return this.http.post(this.getBaseUrl() + 'api/SavingsPayments/Fetch', body, requestOptions).map(x => x.json());
    let body = this.selectedInterestPayments;
    const headers = new HttpHeaders();
    headers.set('Content-Type', 'application/json; charset=utf-8');
    return this.httpClient.post<any>( this.getBaseUrl() +  'api/SavingsPayments/Fetch', body,{headers: headers});
  }
}
